import { useEffect } from 'react';
// utils
import Intercom from '@intercom/messenger-js-sdk';
import { useProfileQuery } from '@/services/customer/profile/profile.queries';
import { useAccountQuery } from '@/services/customer/account/account.queries';
import useSandboxStore from '@/modules/Sandbox/Sandbox.store.ts';
import { useVibeModeDock } from '@/modules/VibeMode/hooks/useVibeModeDock';

const Widget = () => {
    const { data: profile } = useProfileQuery();
    const { data: account } = useAccountQuery();
    const isChatOpened = useSandboxStore((state) => state.isChatOpened);
    const { isDockOpen, dockWidth } = useVibeModeDock();

    const OpenedPadding = 60;
    const ClosedPadding = 40;
    const dockOffset = isDockOpen ? dockWidth : 0;

    useEffect(() => {
        if (profile && account) {
            Intercom({
                app_id: import.meta.env.VITE_INTERCOM_APP_ID,
                user_id: account.id,
                name: account.name,
                email: account.email,
                customer_idn: profile.idn,
                hide_default_launcher: false,
                horizontal_padding:
                    (isChatOpened ? OpenedPadding : ClosedPadding) + dockOffset
            });
        }
    }, [profile, account, isChatOpened, dockOffset]);
    return <div />;
};

export default Widget;
